import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './app.css'
import AppProviders from './providers/AppProviders'
import Splash from './pages/Splash'
import { Jobs, JobDetail } from './pages/Jobs'
import InterviewPage from './pages/Interview'
import { Login, Signup } from './pages/Auth'
import Account from './pages/Account'
import MyJobs from './pages/MyJobs'
import Applicants from './pages/Applicants'
import ApplicationDetail from './pages/ApplicationDetail'
import Messages from './pages/Messages'
import Notifications from './pages/Notifications'
import MyApplications from './pages/MyApplications'
import Contact from './pages/Contact'

const JobRoute = () => {
  const id = location.pathname.split('/').pop()!
  return <JobDetail id={id} />
}
const InterviewRoute = () => {
  const sessionId = location.pathname.split('/').pop()!
  return <InterviewPage sessionId={sessionId} />
}
const ApplicantsRoute = () => {
  const jobId = location.pathname.split('/').slice(-2)[0]!
  return <Applicants jobId={jobId} />
}
const AppRoute = () => {
  const id = location.pathname.split('/').pop()!
  return <ApplicationDetail id={id} />
}
function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobRoute />} />
          <Route path="/jobs/:id/applicants" element={<ApplicantsRoute />} />
          <Route path="/interview/:sessionId" element={<InterviewRoute />} />
          <Route path="/applications" element={<MyApplications />} />
          <Route path="/applications/:id" element={<AppRoute />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/account" element={<Account />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
      </BrowserRouter>
    </AppProviders>
  )
}
createRoot(document.getElementById('root')!).render(<App />)
